import React from "react";
import { useTranslation } from "react-i18next";

export const AppHeader = ({ activePage, setActivePage }) => {
  const { i18n, t } = useTranslation();

  const currentLang = i18n.resolvedLanguage || i18n.language || "en";

  return (
    <header className="w-full max-w-5xl mx-auto mb-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <button
        type="button"
        onClick={() => setActivePage("home")}
        className="text-left text-2xl font-bold tracking-tight text-slate-900 hover:text-slate-700"
      >
        Latwe wesele
      </button>

      <nav className="flex gap-2 text-sm mb-1 flex-wrap">
        <button
          type="button"
          onClick={() => setActivePage("home")}
          className={`px-3 py-1 rounded-full border text-sm font-medium transition-colors duration-150 ${
            activePage === "home"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-transparent text-slate-700 hover:border-slate-300"
          }`}
        >
          {t("nav.home")}
        </button>
        <button
          type="button"
          onClick={() => setActivePage("calculator")}
          className={`px-3 py-1 rounded-full border text-sm font-medium transition-colors duration-150 ${
            activePage === "calculator"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-transparent text-slate-700 hover:border-slate-300"
          }`}
        >
          {t("nav.calculator")}
        </button>
        <button
          type="button"
          onClick={() => setActivePage("vignettes")}
          className={`px-3 py-1 rounded-full border text-sm font-medium transition-colors duration-150 ${
            activePage === "vignettes"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-transparent text-slate-700 hover:border-slate-300"
          }`}
        >
          {t("nav.vignettes", "Vignettes")}
        </button>
        <button
          type="button"
          onClick={() => setActivePage("todos")}
          className={`px-3 py-1 rounded-full border text-sm font-medium transition-colors duration-150 ${
            activePage === "todos"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-transparent text-slate-700 hover:border-slate-300"
          }`}
        >
          {t("nav.todos", "To-dos")}
        </button>
        <button
          type="button"
          onClick={() => setActivePage("contractors")}
          className={`px-3 py-1 rounded-full border text-sm font-medium transition-colors duration-150 ${
            activePage === "contractors"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-transparent text-slate-700 hover:border-slate-300"
          }`}
        >
          {t("nav.contractors")}
        </button>
        <button
          type="button"
          onClick={() => setActivePage("about")}
          className={`px-3 py-1 rounded-full border text-sm font-medium transition-colors duration-150 ${
            activePage === "about"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-transparent text-slate-700 hover:border-slate-300"
          }`}
        >
          {t("nav.about", "About")}
        </button>
      </nav>

      <div className="flex gap-2 text-sm">
        <button
          type="button"
          onClick={() => i18n.changeLanguage("pl")}
          className={`px-2 py-1 rounded border text-xs font-medium ${
            currentLang === "pl"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-slate-300 text-slate-700 bg-white"
          }`}
        >
          {t("language.pl")}
        </button>
        <button
          type="button"
          onClick={() => i18n.changeLanguage("en")}
          className={`px-2 py-1 rounded border text-xs font-medium ${
            currentLang === "en"
              ? "border-slate-900 bg-slate-900 text-white"
              : "border-slate-300 text-slate-700 bg-white"
          }`}
        >
          {t("language.en")}
        </button>
      </div>
    </header>
  );
};
